module.exports = __webpack_public_path__ + "img/logo-min.e1a4fc27.png";